import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaRobot, FaPlus, FaTrash } from "react-icons/fa";
import { baseurl } from "../Baseurl";
import axios from "axios";
import Swal from "sweetalert2";

export default function AutomationSetting() {
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);

  const orgId = localStorage.getItem("organization_id");
  const adminId = localStorage.getItem("adminID");

  // Recurring tasks state (array of objects)
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    if (!adminId) navigate("/");

    const savedTheme = localStorage.getItem("darkMode") === "true";
    setDarkMode(savedTheme);
    document.body.classList.toggle("dark", savedTheme);

    // fetch existing tasks
    fetchTasks();
  }, [navigate, adminId]);

  // Fetch from backend
  const fetchTasks = async () => {
    try {
      const res = await axios.get(
        `${baseurl}getAutomationTasks?adminId=${adminId}&orgId=${orgId}`
      );
      setTasks(res.data.data || []);
    } catch (err) {
      console.error("❌ Failed to fetch tasks:", err);
    }
  };

  // Add new task row
  const addTask = () => {
    setTasks([
      ...tasks,
      { title: "", recurrence_type: "weekly" }, // match DB column
    ]);
  };

  // Remove task (local OR API)
 const removeTask = async (index, task) => {
  // SweetAlert confirmation
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "This task will be permanently deleted.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  });

  if (!result.isConfirmed) return; // stop if user cancels

  // If task is not saved yet (no id), just remove locally
  if (!task.id) {
    const newTasks = [...tasks];
    newTasks.splice(index, 1);
    setTasks(newTasks);
    return;
  }

  // Otherwise call backend delete API
  try {
    await axios.post(`${baseurl}deleteAutomationTask`, {
      id: task.id,
      adminId,
      orgId,
    });

    Swal.fire({
      icon: "success",
      title: "Deleted!",
      text: "Task has been deleted successfully.",
      timer: 1500,
      showConfirmButton: false,
    });

    fetchTasks(); // refresh list
  } catch (err) {
    console.error("❌ Failed to delete task:", err);
    Swal.fire("Error", "Could not delete task", "error");
  }
};


  // Update field for a task
  const updateTask = (index, field, value) => {
    const newTasks = [...tasks];
    newTasks[index][field] = value;
    setTasks(newTasks);
  };

  // Save Recurring Tasks
  const saveRecurringTasks = async () => {
    try {
      const payload = {
        adminId,
        orgId,
        tasks: tasks.map((task) => ({
          id: task.id || null, // update if exists
          title: task.title,
          recurrenceType: task.recurrence_type || task.recurrenceType,
        })),
      };

      console.log("📤 Sending payload:", payload);

      await axios.post(`${baseurl}upsertAutomationTasks`, payload);

      Swal.fire({
        icon: "success",
        title: "Recurring Tasks Saved",
        text: "Your recurring tasks have been saved successfully.",
        timer: 2000,
        showConfirmButton: false,
      });

      fetchTasks(); // re-fetch tasks to sync IDs
    } catch (err) {
      console.error("❌ Failed to save recurring tasks:", err);
      Swal.fire("Error", "Could not save recurring tasks", "error");
    }
  };

  return (
    <>
      <div className="settings-header">
        <h3>Automation Settings</h3>
      </div>

      <div className="settings-section">
        <div className="settings-option-item">
          <h4 className="section-title-inline">
            <FaRobot style={{ marginRight: "8px" }} />
            Recurring Tasks
          </h4>
        </div>
        <p className="section-description">
          Add recurring tasks (like paying rent or monthly reports). These will
          automatically reappear in your To-Do list.
        </p>

        {/* Task Rows */}
        {tasks.map((task, index) => (
          <div
            key={index}
            className="task-row"
            style={{
              display: "flex",
              gap: "15px",
              alignItems: "flex-end",
              marginBottom: "10px",
              borderBottom: "1px solid #ddd",
              paddingBottom: "10px",
            }}
          >
            {/* Task Title */}
            <div style={{ flex: 2 }}>
              <label>Task Title:</label>
              <input
                type="text"
                className="form-control"
                value={task.title}
                onChange={(e) => updateTask(index, "title", e.target.value)}
                placeholder="Enter task title"
              />
            </div>

            {/* Recurrence Type */}
            <div style={{ flex: 1 }}>
              <label>Repeat:</label>
              <select
                className="form-select"
                value={task.recurrence_type || task.recurrenceType}
                onChange={(e) =>
                  updateTask(index, "recurrence_type", e.target.value)
                }
              >
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="quarterly">Quarterly</option>
                <option value="yearly">Yearly</option>
              </select>
            </div>

            {/* Remove Button */}
            <div>
              <button
                className="btn btn-danger"
                onClick={() => removeTask(index, task)}
              >
                <FaTrash />
              </button>
            </div>
          </div>
        ))}

        {/* Add Task Button */}
        <button className="btn btn-secondary mt-2" onClick={addTask}>
          <FaPlus style={{ marginRight: "5px" }} />
          Add Task
        </button>

        {/* Save Button */}
        <div style={{ marginTop: "20px" }}>
          <button className="btn btn-primary" onClick={saveRecurringTasks}>
            Save All Tasks
          </button>
        </div>
      </div>
    </>
  );
}
